/* Product-preview projection only. Manufacturing output uses WeddingRenderer's
 * independent millimetre layout; classic cup photography is not a measurement.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(require('./je-birthflower-product-calibration.js'));
  else root.WeddingProductCalibration = factory(root.BloomProductCalibration);
})(typeof globalThis !== 'undefined' ? globalThis : this, function (Bloom) {
  'use strict';
  function rectangle(value, label) {
    if (!value || !['x','y','width','height'].every(key => Number.isFinite(value[key])) ||
        value.x < 0 || value.y < 0 || value.width <= 0 || value.height <= 0 ||
        value.x + value.width > 1.000001 || value.y + value.height > 1.000001) {
      throw new RangeError(label + ' must fit the normalized photo stage.');
    }
    return value;
  }
  function resolve(photo) {
    if (!photo || typeof photo !== 'object') throw new TypeError('Choose a product preview photo.');
    if (photo.faceCalibration) {
      if (!Bloom) throw new Error('The Owala preview calibration did not load. Reload to retry.');
      return Bloom.resolve(photo);
    }
    if (!['stanley','frostbuddy','owala'].includes(photo.productId) || photo.approximate !== true || photo.previewOnly !== true) {
      throw new RangeError('The classic product photo needs an explicit approximate preview profile.');
    }
    rectangle(photo.crop, 'The photo crop'); rectangle(photo.stageCropRect, 'The photo frame');
    const region = { ...rectangle(photo.stageArea, 'The preview area') };
    if (![photo.widthMm,photo.heightMm].every(value => Number.isFinite(value) && value > 0)) {
      throw new RangeError('The nominal product-preview area must have positive dimensions.');
    }
    const scaleX = region.width / photo.widthMm, scaleY = region.height / photo.heightMm;
    return { region, physicalArea: { widthMm:photo.widthMm, heightMm:photo.heightMm },
      face: { top:region.y, bottom:region.y+region.height, height:region.height, heightMm:photo.heightMm,
        centerX:region.x+region.width/2, centerY:region.y+region.height/2 },
      scale:scaleY, scaleX, scaleY, calibrated:false, widthCalibrated:false,
      approximate:true, previewOnly:true, marginMm:0 };
  }
  function photoForSize(photo, size) {
    if (!photo) return null;
    if (photo.faceCalibration) {
      if (!Bloom) throw new Error('The Owala preview calibration did not load. Reload to retry.');
      return Bloom.photoForSize(photo, size);
    }
    const normalized = value => String(value).toLowerCase().replace(/\s/g, '');
    return normalized(photo.size) === normalized(size) ? photo : null;
  }
  return Object.freeze({ resolve, photoForSize });
});
